import { render, staticRenderFns } from "./JiraCreateProjectForm.vue?vue&type=template&id=64e4f23b"
import script from "./JiraCreateProjectForm.vue?vue&type=script&lang=js"
export * from "./JiraCreateProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports